import { EnderecoCep } from "./enderecoCep";

export class EnderecoLogradouro {

    cdRestart: string;
    cdMsgemRetorno: string;
    dsMsgemRetorno: string;
    listaEndereco: EnderecoCep[] = [];
    
    constructor() {}
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/enderecoLogradouro.ts